import React, { useState } from "react";
import { submitSupportInquiry } from "../Backend/website";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const ContactPage = () => {
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "General Inquiry",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    const result = await submitSupportInquiry(formData);
    setLoader(false);

    if (result.success) {
      Swal.fire({
        title: "Message Received!",
        text: "We'll get back to you within 24-48 hours.",
        icon: "success",
        confirmButtonColor: "#E63946",
        background: "#ffffff",
        customClass: { popup: "rounded-[2rem]" },
      });
      setFormData({
        name: "",
        email: "",
        subject: "General Inquiry",
        message: "",
      });
    } else {
      Swal.fire({
        title: "Error",
        text: result.message,
        icon: "error",
        confirmButtonColor: "#0B1C2D",
      });
    }
  };

  return (
    <div className="bg-white min-h-screen font-sans selection:bg-[#E63946] selection:text-white overflow-x-hidden">
      <section className="relative pt-28 sm:pt-36 lg:pt-44 pb-16 sm:pb-24 lg:pb-32 bg-[#0B1C2D] overflow-hidden">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-[#E63946]/10 blur-[120px] rounded-full translate-x-1/2"></div>
        <div className="mx-auto w-[95%] md:w-[90%] relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="lg:w-1/2 text-center lg:text-left w-full">
              <Link
                to="/"
                className="inline-flex items-center text-sm font-bold text-[#E63946] mb-6 sm:mb-8 group"
              >
                <span className="material-symbols-outlined text-sm mr-2 group-hover:-translate-x-1 transition-transform">
                  arrow_back
                </span>
                Return to Homepage
              </Link>
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-white tracking-tighter leading-[0.95] mb-6 sm:mb-8">
                Let's Start a <br />
                <span className="text-[#E63946]">Conversation.</span>
              </h1>
              <p className="max-w-xl mx-auto lg:mx-0 text-base sm:text-lg lg:text-xl text-slate-400 font-medium leading-relaxed">
                Contact our support nodes across India for high-priority
                technical assistance.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        id="contact-form-section"
        className="py-12 sm:py-16 lg:py-24 bg-slate-50"
      >
        <div className="mx-auto w-[95%] md:w-[90%]">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 xl:gap-16 items-stretch lg:items-start">
            <div className="lg:w-1/3 space-y-4 sm:space-y-6 w-full">
              <div className="p-6 sm:p-8 rounded-2xl sm:rounded-[2rem] bg-white border border-[#E2E8F0] shadow-sm">
                <p className="text-[10px] font-black uppercase tracking-widest text-[#E63946] mb-4">
                  Direct Contact
                </p>
                <div className="space-y-5 sm:space-y-6">
                  <div>
                    <h4 className="text-sm font-bold text-[#94A3B8] mb-1">
                      Email
                    </h4>
                    <p className="text-base sm:text-lg font-black text-[#0B1C2D] break-all">
                      support@contacthq.in
                    </p>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-[#94A3B8] mb-1">
                      Phone
                    </h4>
                    <p className="text-base sm:text-lg font-black text-[#0B1C2D]">
                      +91 9732149101
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-6 sm:p-8 rounded-2xl sm:rounded-[2rem] bg-[#0B1C2D] text-white">
                <span className="material-symbols-outlined text-[#E63946] mb-3 sm:mb-4">
                  share_location
                </span>
                <h4 className="text-lg sm:text-xl font-black mb-2">
                  Regional Hubs
                </h4>
                <p className="text-sm text-slate-400 leading-relaxed">
                  Nodes active in Kolkata, Bengaluru, Hyderabad, Jaipur, and
                  Delhi for local speed.
                </p>
              </div>
            </div>

            <div className="lg:w-2/3 w-full">
              <div className="bg-white p-5 sm:p-8 md:p-12 lg:p-14 rounded-2xl sm:rounded-[2rem] lg:rounded-[3rem] border border-[#E2E8F0] shadow-xl sm:shadow-2xl shadow-slate-200/50">
                <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-8">
                    <div className="space-y-2">
                      <label className="text-xs font-black uppercase tracking-widest text-[#0B1C2D] ml-1 sm:ml-2">
                        Full Name
                      </label>
                      <input
                        name="name"
                        type="text"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Anirban Das"
                        className="w-full px-4 sm:px-6 py-3.5 sm:py-4 rounded-xl sm:rounded-2xl bg-slate-50 border-2 border-transparent focus:border-[#E63946] focus:bg-white outline-none transition-all font-medium text-[#0B1C2D]"
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="text-xs font-black uppercase tracking-widest text-[#0B1C2D] ml-1 sm:ml-2">
                        Work Email
                      </label>
                      <input
                        name="email"
                        type="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="anirban@company.in"
                        className="w-full px-4 sm:px-6 py-3.5 sm:py-4 rounded-xl sm:rounded-2xl bg-slate-50 border-2 border-transparent focus:border-[#E63946] focus:bg-white outline-none transition-all font-medium text-[#0B1C2D]"
                      />
                    </div>
                  </div>

                  <div className="space-y-3 sm:space-y-4">
                    <label className="text-xs font-black uppercase tracking-widest text-[#0B1C2D] ml-1 sm:ml-2">
                      Inquiry Type
                    </label>
                    <div className="flex flex-wrap gap-2 sm:gap-3">
                      {[
                        "Technical Support",
                        "Enterprise Setup",
                        "API Query",
                        "Report Bug",
                      ].map((btn) => (
                        <button
                          key={btn}
                          type="button"
                          onClick={() =>
                            setFormData({ ...formData, subject: btn })
                          }
                          className={`px-3.5 sm:px-6 py-2.5 sm:py-3 rounded-xl text-[11px] sm:text-xs font-bold border-2 transition-all whitespace-nowrap ${
                            formData.subject === btn
                              ? "bg-[#E63946] border-[#E63946] text-white shadow-lg shadow-[#E63946]/20"
                              : "bg-white border-[#F1F5F9] text-[#64748B] hover:border-[#E2E8F0]"
                          }`}
                        >
                          {btn}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="text-xs font-black uppercase tracking-widest text-[#0B1C2D] ml-1 sm:ml-2">
                      Message
                    </label>
                    <textarea
                      name="message"
                      rows="5"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your project or the issue you are facing..."
                      className="w-full px-4 sm:px-6 py-3.5 sm:py-4 rounded-xl sm:rounded-2xl bg-slate-50 border-2 border-transparent focus:border-[#E63946] focus:bg-white outline-none transition-all font-medium text-[#0B1C2D] resize-none"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={loader}
                    className="group relative w-full overflow-hidden rounded-xl sm:rounded-2xl bg-[#0B1C2D] px-6 sm:px-8 py-4 sm:py-5 text-sm font-black text-white transition-all hover:bg-[#E63946] disabled:opacity-70"
                  >
                    <div className="relative z-10 flex items-center justify-center gap-3">
                      {loader ? (
                        <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                      ) : (
                        <>
                          <span className="text-center">
                            Send to Centralized Inbox
                          </span>
                          <span className="material-symbols-outlined transition-transform group-hover:translate-x-1 shrink-0">
                            arrow_forward
                          </span>
                        </>
                      )}
                    </div>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
